import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";

import "./assets/scss/main.scss";

import { ChakraProvider } from "@chakra-ui/react";

import configureStore from "./redux/store";
import { Provider } from "react-redux";

import App from "./components/pages/App/App";

const store = configureStore();

// React Query client
const queryClient = new QueryClient();

ReactDOM.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ChakraProvider>
          <App />
        </ChakraProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </Provider>,
  document.getElementById("root")
);